export default '4.74.0';